import { CopyFilled, CopyOutlined, UserOutlined } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import React, { useState } from 'react';
import Action from '../../Components/Action/action.component';
// import NewPatient from '../../Components/Action/new.patient';
import './actions.section.css';
// import NewExam2 from '../../Components/Action/new.exam';
import RealTime from '../../Components/RealTime/real.time';
import NewExam from '../../Components/NewExam/NewExam';
import MultiStepUploadModal from '../../Components/MultiStepUlpload/multi-step-upload-modal';
import { useTranslation } from 'react-i18next';
import MultiStepCollapsible from '../../Components/MultiStepUlpload/upload-collapsible-exam';
import { NewCaseWizard } from '../../ComponnentsUI/NewCaseWizard/NewCaseWizard';
import { NewPatient } from '../../ComponnentsUI/NewPatient/NewPatient';
import { UploadStudyMode } from '../../ComponnentsUI/UploadStudyMode/UploadStudyMode';
import { NewCaseReverseUpload } from '../../ComponnentsUI/NewCaseReverseUpload/NewCaseReverseUpload';
import { GetConnectionData } from '../../ComponnentsUI/GetConnectionData/GetConnectionData';
import { usePermissions } from '../../../helpers/acl/permissions';

const actions = [
  {
    title: 'actions.newExam',
    description: 'actions.newExamDescription',
  },
  {
    title: 'actions.newPatient',
    description: 'actions.newPatientDescription',
  },
  {
    title: 'actions.newSource',
    description: 'actions.newSourceDescription',
  },
  {
    title: 'actions.realtime',
    description: 'actions.realtimeDescription',
  },
];
interface ActionsProps {
  setIsRefetchPatients?: (value: boolean) => void;
  setIsRefetchExams?: (value: boolean) => void;
}
const Actions: React.FC<ActionsProps> = ({
  setIsRefetchPatients,
  setIsRefetchExams,
}) => {
  const { t } = useTranslation('Actions');
  const { can } = usePermissions();

  const canSeeConnectionData = can('pacs_device.read');
  const canCreateExam = can('study.acquire');
  const canCreatePatient = can('patient.create');
  const canRealtime = can('study.acquire');
  return (
    <div className="flex flex-row items-center justify-end gap-2 sm:gap-3">
      {canSeeConnectionData && <GetConnectionData />}
      {canCreateExam && <NewCaseReverseUpload />}
      {canCreatePatient && <NewPatient />}
      {canRealtime && <UploadStudyMode />}
    </div>
  );
};

export default Actions;
